import {AuthRepository} from '@domain/model/Auth/AuthRepository';
import {AuthLoginGoogle} from '@domain/model/Auth/AuthLoginGoogle';

export const LoginWithGoogle = (repo: AuthRepository) => (params: AuthLoginGoogle) => repo.loginWithGoogle(params);
